<template>
  <h2 class="text-purple-ap-100 font-semibold leading-tight">
    {{ name }}
    <i
      v-if="isFavorite"
      class="isFaved material-icons align-text-top text-3xl text-yellow-500"
      >star</i
    >
  </h2>
</template>

<script>
export default {
  name: "AuPairName",
  props: ["name", "auPairPromoProfileId"],
  computed: {
    isFavorite() {
      return this.$store.state.user.favoriteAuPairs.includes(
        this.auPairPromoProfileId
      );
    },
  },
};
</script>
